import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
const map = require('lodash/map');

const propTypes = {
    modalTitle: PropTypes.string,
    message: PropTypes.string,
    buttonData: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, handler: PropTypes.func.isRequired })),
};

const defaultProps = {
    show: true,
    hasError: false,
    modalTitle: 'Select Option',
    message: '',
    buttonData: []
};

function ThreeModal(props) {
    return (
        <Modal
            show
            enforceFocus={false}
            autoFocus
            backdrop={false}
            animation={false}
            keyboard
            //container={mountNode}
            //onHide={props.closeHandler}
        >
            <Modal.Header>
                <Modal.Title>{props.modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.message}
            </Modal.Body>

            <Modal.Footer>
            {map(props.buttonData, function(bd, i) { 
                let extraParams = {};
                if (bd.disabled) {
                    extraParams.disabled = bd.disabled;
                }
                if (bd.variant) {
                    extraParams.variant = bd.variant;
                }
                return (
                <Button key={i} {...extraParams} onClick={bd.handler}>{bd.text}</Button>
            )})}
            </Modal.Footer>
        </Modal>
    );
}

ThreeModal.propTypes = propTypes;
ThreeModal.defaultProps = defaultProps;

export default ThreeModal;
